/* global axios */
import ApiClient from './ApiClient';

class InternalChatAPI extends ApiClient {
  constructor() {
    super('internal_chats', { accountScoped: true });
  }

  // Lista todos os chats do usuário
  getChats() {
    return axios.get(this.url);
  }

  // Obtém detalhes de um chat
  getChat(chatId) {
    return axios.get(`${this.url}/${chatId}`);
  }

  // Cria um novo chat em grupo
  createGroupChat({ name, description, participantIds }) {
    return axios.post(this.url, {
      internal_chat: {
        name,
        description,
        chat_type: 'group',
      },
      participant_ids: participantIds,
    });
  }

  // Cria ou obtém chat direto com outro usuário
  createDirectChat(userId) {
    return axios.post(`${this.url}/create_direct`, {
      user_id: userId,
    });
  }

  // Atualiza informações do chat (nome, descrição)
  updateChat(chatId, { name, description }) {
    return axios.patch(`${this.url}/${chatId}`, {
      internal_chat: { name, description },
    });
  }

  // Deleta um chat
  deleteChat(chatId) {
    return axios.delete(`${this.url}/${chatId}`);
  }

  // Obtém participantes do chat
  getParticipants(chatId) {
    return axios.get(`${this.url}/${chatId}/participants`);
  }

  // Adiciona participante
  addParticipant(chatId, userId, isAdmin = false) {
    return axios.post(`${this.url}/${chatId}/add_participant`, {
      user_id: userId,
      is_admin: isAdmin,
    });
  }

  // Remove participante
  removeParticipant(chatId, userId) {
    return axios.delete(`${this.url}/${chatId}/remove_participant`, {
      data: { user_id: userId },
    });
  }

  // Marca chat como lido
  markAsRead(chatId) {
    return axios.post(`${this.url}/${chatId}/mark_as_read`);
  }

  // Obtém contagem de não lidos total
  getUnreadCount() {
    return axios.get(`${this.url}/unread_count`);
  }

  // ========== Mensagens ==========

  // Lista mensagens de um chat
  getMessages(chatId, { before, after, limit = 50 } = {}) {
    const params = new URLSearchParams();
    if (before) params.append('before', before);
    if (after) params.append('after', after);
    params.append('limit', limit);

    return axios.get(`${this.url}/${chatId}/messages?${params.toString()}`);
  }

  // Obtém uma mensagem específica
  getMessage(chatId, messageId) {
    return axios.get(`${this.url}/${chatId}/messages/${messageId}`);
  }

  // Envia mensagem de texto
  sendMessage(chatId, { content, replyToId, contentAttributes }) {
    return axios.post(`${this.url}/${chatId}/messages`, {
      message: {
        content,
        reply_to_id: replyToId,
        content_attributes: contentAttributes,
      },
    });
  }

  // Envia mensagem com anexos
  sendMessageWithAttachments(chatId, formData) {
    return axios.post(`${this.url}/${chatId}/messages`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  // Deleta mensagem
  deleteMessage(chatId, messageId) {
    return axios.delete(`${this.url}/${chatId}/messages/${messageId}`);
  }
}

export default new InternalChatAPI();
